<div
  class="settings-box color-{{ color }}"
  [class.first]="first"
  [class.last]="last"
  [class.small]="small"
  [class.primary-hover]="primaryHover"
>
  <div class="box-icon {{ iconStyle }}" *ngIf="image || icon">
    <img [src]="image" alt="" *ngIf="image" />
    <app-svg [src]="icon" *ngIf="icon" [attr.size]="iconSize"></app-svg>
    <div class="extra-icon-content">
      <ng-content select="app-settings-box-icon-content"></ng-content>
    </div>
  </div>
  <div class="box-content">
    <h4>
      {{ title }} <span class="label label-orange" *ngIf="soon">SOON</span>
      <ng-container *ngIf="permission">
        <app-pro-tag
          [permission]="permission"
          *ngIf="'!' + permission | permissions : gallery"
          [tenantId]="gallery?.['tenant']?.['id'] || gallery?.['tenant']"
        ></app-pro-tag>
      </ng-container>
    </h4>
    <p class="standard-text">
      <ng-content></ng-content>
    </p>
  </div>
  <div class="box-cta" *ngIf="!arrowCta && !switchCta && !selectCta">
    <ng-container *onlyForScreens="['desktop', 'tablet']">
      <button
        appButton
        [color]="ctaColor"
        [name]="name"
        [location]="location"
        spacing="3"
        weight="bold"
        [class.disabled]="(soon && !soonDontDisable) || !(permission | permissions : gallery)"
        (click)="onClick.emit()"
        *ngIf="!link && !externalLink"
      >
        <span [class.hidden-text]="buttonLoading"> {{ ctaText }}</span>
        <app-loading-indicator *ngIf="buttonLoading" color="white" size="small" class="button-loading-indicator">
        </app-loading-indicator>
      </button>
      <a
        appButton
        [color]="ctaColor"
        [routerLink]="link"
        [name]="name"
        [location]="location"
        spacing="3"
        weight="bold"
        [class.disabled]="(soon && !soonDontDisable) || !(permission | permissions : gallery)"
        (click)="onClick.emit()"
        *ngIf="link"
        >{{ ctaText }}</a
      >

      <a
        appButton
        [color]="ctaColor"
        [href]="externalLink"
        target="_blank"
        [name]="name"
        [location]="location"
        spacing="3"
        weight="bold"
        [class.disabled]="(soon && !soonDontDisable) || !(permission | permissions : gallery)"
        (click)="onClick.emit()"
        *ngIf="externalLink"
        >{{ ctaText }}</a
      >
    </ng-container>

    <ng-container *onlyForScreens="['mobile']">
      <button
        appButton
        [name]="name"
        [location]="location"
        height="1"
        color="{{ ctaColor || 'simple-gray' }}"
        [iconButton]="true"
        (click)="onClick.emit()"
        *ngIf="!link && !externalLink"
        [class.disabled]="(soon && !soonDontDisable) || !(permission | permissions : gallery)"
      >
        <app-svg src="/assets/icons/edit.svg"></app-svg>
      </button>
      <a
        appButton
        [routerLink]="link"
        [name]="name"
        [location]="location"
        height="1"
        color="{{ ctaColor || 'simple-gray' }}"
        [iconButton]="true"
        (click)="onClick.emit()"
        *ngIf="link"
        [class.disabled]="(soon && !soonDontDisable) || !(permission | permissions : gallery)"
      >
        <app-svg src="/assets/icons/stroke/arrow-right.svg"></app-svg>
      </a>
      <a
        appButton
        [href]="externalLink"
        target="_blank"
        [name]="name"
        [location]="location"
        height="1"
        color="{{ ctaColor || 'simple-gray' }}"
        [iconButton]="true"
        (click)="onClick.emit()"
        *ngIf="externalLink"
        [class.disabled]="(soon && !soonDontDisable) || !(permission | permissions : gallery)"
      >
        <app-svg src="/assets/icons/stroke/arrow-right.svg"></app-svg>
      </a>
    </ng-container>
  </div>
  <div *ngIf="arrowCta" class="arrow-cta" [class.loading]="buttonLoading">
    <a
      appButton
      [routerLink]="link"
      [name]="name"
      [location]="location"
      height="1"
      color="{{ ctaColor || 'simple-gray' }}"
      [iconButton]="true"
      (click)="onClick.emit()"
      [class.disabled]="(soon && !soonDontDisable) || !(permission | permissions : gallery)"
    >
      <app-svg src="/assets/icons/stroke/arrow-right.svg" *ngIf="!buttonLoading"></app-svg>
      <app-loading-indicator *ngIf="buttonLoading" color="primary" size="small" class="button-loading-indicator">
      </app-loading-indicator>
    </a>
  </div>
  <div class="switch" appTransitionPreventor *ngIf="switchCta">
    <input
      type="checkbox"
      id="switch-{{ id }}"
      [(ngModel)]="switchValue"
      (ngModelChange)="onSwitch.emit(switchValue)"
      [disabled]="!(permission | permissions : gallery) && (!switchValue || !overridePermissionIfTrue)"
    />
    <label for="switch-{{ id }}"></label>
  </div>

  <app-context-menu *ngIf="selectCta" [options]="{ width: '240px', noSpacing: true }" class="select" #menu>
    <ng-container contextButton>
      <button name="DONTREPORT" appButton contextButton [hasIcon]="true" *onlyForScreens="['desktop', 'tablet']">
        <span class="select-value">{{ selectValue | capitalize }}</span>
        <app-svg src="/assets/icons/chevron-down.svg"></app-svg>
      </button>
      <button
        name="DONTREPORT"
        appButton
        contextButton
        [iconButton]="true"
        height="1"
        color="simple-gray"
        *onlyForScreens="['mobile']"
      >
        <app-svg src="/assets/icons/edit.svg"></app-svg>
      </button>
    </ng-container>

    <div class="button-menu" contextContent>
      <app-button-menu-item
        name="DONTREPORT"
        location="settings-box"
        *ngFor="let option of selectOptions"
        [icon]="option.icon"
        [color]="selectValue === option.value ? option.color : 'simple'"
        [weight]="selectValue === option.value ? 'bold' : 'normal'"
        [iconColor]="option.iconColor"
        [fullWidth]="true"
        (click)="onSwitch.emit(option.value); menu.close()"
      >
        <div class="select-option-value">
          <span>{{ option.text }}</span>
          <app-svg *ngIf="selectValue === option.value" src="/assets/icons/checkmark.svg"></app-svg>
        </div>
      </app-button-menu-item>
    </div>
  </app-context-menu>
</div>
